export default "__VITE_PUBLIC_ASSET__51d9a364__"